export default "__VITE_PUBLIC_ASSET__ff9d383c__"